import React from 'react';
import PropTypes from 'prop-types';
import Paragraph from '../paragraph';
import Icon from '../icon';
import { iconsList } from '../icon/glyphs';

const IconFeature = ({ iconGlyph = null, title = null, description = null }) => (
  <div className="ws-ui-icon-feature">
    {iconGlyph && (
      <div className="ws-ui-icon-feature__icon">
        <Icon glyph={iconGlyph} type="accent" size="100%" />
      </div>
    )}
    <div className="ws-ui-icon-feature__description">
      {title && (
        <Paragraph>
          <strong>{title}</strong>
        </Paragraph>
      )}
      {description && (
        <div className="ws-ui-icon-feature__description-subtitle">
          <Paragraph size="medium" appearance="medium-emphasis">
            {description}
          </Paragraph>
        </div>
      )}
    </div>
  </div>
);

IconFeature.propTypes = {
  iconGlyph: PropTypes.oneOf(iconsList),
  title: PropTypes.string,
  description: PropTypes.string,
};

export default IconFeature;
